import { Box, Button, IconButton, Typography } from '@mui/material';
import MetricRuleRow from 'components/@home/@settings/Tabs/Agents/metricPanels/MetricRuleRow';
import CloseIcon from 'mdi-react/CloseIcon';
import PlusIcon from 'mdi-react/PlusIcon';
import { arrayOf, func, number, object } from 'prop-types';
import React from 'react';
import { I18n } from 'utils/i18n';

const newCondition = () => ({ operator: 'has', tagId: null });

const MetricRuleGroupCard = ({ group, index, tags, onChange, onRemove }) => {
  const conditions = group.conditions || [];

  const updateCondition = (idx, next) => {
    onChange({ ...group, conditions: conditions.map((c, i) => (i === idx ? next : c)) });
  };
  const removeCondition = idx => {
    onChange({ ...group, conditions: conditions.filter((_, i) => i !== idx) });
  };
  const addCondition = () => {
    onChange({
      ...group,
      operator: group.operator || 'and',
      conditions: [...conditions, newCondition()],
    });
  };

  return (
    <Box
      sx={{
        border: 1,
        borderColor: 'divider',
        borderRadius: '8px',
        bgcolor: 'background.default',
        p: 2,
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Typography sx={{ fontSize: theme => theme.typography.pxToRem(13.5), fontWeight: 600 }}>
          {I18n.t('AgenticChatFlow.MetricsRuleGroupTitle', { n: index + 1 })}
        </Typography>
        <IconButton size="small" onClick={onRemove}>
          <CloseIcon size={18} />
        </IconButton>
      </Box>
      {conditions.map((condition, idx) => (
        <MetricRuleRow
          key={idx}
          condition={condition}
          tags={tags}
          onChange={next => updateCondition(idx, next)}
          onRemove={() => removeCondition(idx)}
        />
      ))}
      <Button
        variant="outlined"
        size="small"
        sx={{ alignSelf: 'flex-start', textTransform: 'none', mt: 1 }}
        startIcon={<PlusIcon size={16} />}
        onClick={addCondition}
      >
        {I18n.t('AgenticChatFlow.MetricsAddRule')}
      </Button>
    </Box>
  );
};

MetricRuleGroupCard.propTypes = {
  group: object.isRequired,
  index: number.isRequired,
  tags: arrayOf(object).isRequired,
  onChange: func.isRequired,
  onRemove: func.isRequired,
};

export default MetricRuleGroupCard;
